import React from "react";

import { templates } from "@reactivated";

import { ImageChooserBlock } from "@thelabnyc/thelabui/src/components/ImageChooserBlock";

import { Themed } from "../../styles/themes";
import { Clickable } from "../Clickables";
import { ProductCard } from "../ProductCard";

import styles from "./index.module.scss";

interface Props {
    results: templates.SearchResultsTemplate["results"][number][];
}

export const SearchResults = ({ results }: Props) => (
    <ol className={styles.grid}>
        {results.map((item, index) =>
            item.type === "product" ? (
                <ProductCard
                    key={index}
                    product={item.product}
                    layout="horizontal"
                    tag="li"
                />
            ) : (
                <Themed
                    key={index}
                    theme="offWhite"
                    tag="li"
                    className={item.image ? styles.cardWithImage : styles.card}
                >
                    {item.image && (
                        <ImageChooserBlock
                            value={item.image}
                            attrs={{ className: styles.picture }}
                        />
                    )}
                    <Clickable href={item.url ?? undefined}>
                        <div className={styles.content}>
                            <h2 className={styles.title}>{item.title}</h2>
                            {item.description && <p>{item.description}</p>}
                        </div>
                    </Clickable>
                </Themed>
            ),
        )}
    </ol>
);
